<div [hidden]="!selected">
  <ng-content></ng-content> 
</div>